import { Trash, Warning } from "@phosphor-icons/react";

import { Button } from "../../../components/ui/button";

export function ProjectDeleteDialog({
  open,
  project,
  deleteOneDrive,
  onDeleteOneDriveChange,
  onClose,
  onConfirm,
}) {
  if (!open || !project) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="delete-confirm-overlay">
      <div className="absolute inset-0 bg-slate-900/40" onClick={onClose} />
      <div className="relative z-10 bg-white border border-slate-200 rounded-sm shadow-xl max-w-sm w-full p-5">
        <div className="flex items-start gap-3 mb-4">
          <Warning size={20} className="text-red-500 flex-shrink-0 mt-0.5" weight="fill" />
          <div>
            <p className="text-sm font-semibold text-slate-900">Delete this project?</p>
            <p className="text-xs text-slate-500 mt-1">The project record will be permanently removed. This cannot be undone.</p>
          </div>
        </div>
        {project.onedrive_folder_id && (
          <label className="flex items-start gap-2.5 mb-4 p-3 rounded bg-red-50 border border-red-100 cursor-pointer" data-testid="delete-onedrive-checkbox-label">
            <input
              type="checkbox"
              data-testid="delete-onedrive-checkbox"
              checked={deleteOneDrive}
              onChange={(e) => onDeleteOneDriveChange(e.target.checked)}
              className="mt-0.5 accent-red-600 cursor-pointer"
            />
            <span className="text-xs text-red-700 leading-snug">
              <span className="font-semibold">Also permanently delete the OneDrive folder</span> and all files inside it. This cannot be undone.
            </span>
          </label>
        )}
        <div className="flex items-center justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onClose}>Cancel</Button>
          <Button size="sm" onClick={() => onConfirm(deleteOneDrive)} className="bg-red-600 hover:bg-red-700 text-white" data-testid="confirm-delete-project">
            <Trash size={13} className="mr-1" /> Delete Project
          </Button>
        </div>
      </div>
    </div>
  );
}
